// Expression evaluator for braced loop placeholders like `${ind + 1}`.
// It supports precedence, parentheses, and string-aware joins.
import type { LuisArrayVariables, LuisObjectVariables } from '../../types'
import { evaluateParsedLoopExpression } from './placeholder-expression-evaluate'

// Evaluate one `${...}` expression against loop scope values.
export function evaluateLoopPlaceholderExpression(
  expression: string,
  scope: Record<string, string>,
  variables: Record<string, string> = {},
  objectVariables: LuisObjectVariables = {},
  arrays: LuisArrayVariables = {},
): string | null {
  // Return the delegated parser/evaluator output.
  return evaluateParsedLoopExpression(expression, scope, variables, objectVariables, arrays)
}
